module.exports = {
      id: "arabic-usage",
      viewBox: "0 0 24 16",
      url: __webpack_public_path__ + "sprite-dd6387.smartcharts.svg#arabic-usage",
      toString: function () {
        return this.url;
      }
    }